<style>
	.tips-mask-t{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 50;
		background-color: rgba(0,0,0,.4);
		/*opacity: 0;*/
	}
	.tips-mask-t .tips-wrapper{
		position: absolute;
		width: 100%;
		margin-top: -90px;
		background-color: #eee;
		box-shadow: 0px 5px 10px rgba(0,0,0,.1)
	}
	.tips-mask-t .tips-wrapper .tips-font{
		margin: 0;
	    text-align: center;
	    border-bottom: solid 1px #f3f3f3;
	    box-sizing: border-box;
	    vertical-align: middle;
	    background-color: #fff;
	}
	.tips-mask-t .tips-wrapper .tips-font p{
		height: auto;
	    vertical-align: middle;
	    font-size: .9em;
	    margin: 0;
	    padding: 10px;
	    color: #aaa;
	}
	.tips-mask-t .tips-wrapper .tips-btns{
		margin: 0;
		padding: 0;
		text-align: center;
	}
	.tips-mask-t .tips-wrapper .tips-btns .tips-two-btn{
		display: block;
		font-size: 1.2em;
		width: 100%;
		padding: .6em 0;
		box-sizing: border-box;
		background-color: #fff;
	}
	.tips-mask-t .tips-wrapper .tips-btns .tips-one-btn{
		display: block;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		color:#25b8d4;
	}
	.tips-mask-t .tips-wrapper .tips-btns .tips-marbot{
		margin-bottom: .5em;
	}
	.tips-start{
		bottom: 0%;
		animation: tipsStart .3s;
		-webkit-animation: tipsStart .3s;
	}
	@keyframes tipsStart
	{
	    from {bottom: -40%;}
	    to {bottom: 0%;}
	}
	@-webkit-keyframes tipsStart
	{
	    from {bottom: -40%;}
	    to {bottom: 0%;}
	}
	.tips-end{
		bottom: -40%;
		animation: tipsEnd .3s;
		-webkit-animation: tipsEnd .3s;
	}
	@keyframes tipsEnd
	{
	    from {bottom: 0%;}
	    to {bottom: -40%;}
	}
	@-webkit-keyframes tipsEnd
	{
	    from {bottom: 0%;}
	    to {bottom: -40%;}
	}
</style>
<template>
	<div class="tips-mask-t" @click="onCancel" v-show="tipsMaks">
		<div class="tips-wrapper" :class="{'tips-start':topMove,'tips-end':!topMove}" @click.stop>
			<div class="tips-font" v-if="hasTipsFont"><p>{{tipsFont}}</p></div>
			<div class="tips-btns">
				<a class="tips-two-btn tips-marbot red-font" @click.stop="onConfirmS">{{btnFont[0]}}</a>
				<a class="tips-two-btn tips-marbot" v-if="btnFont.length > 2" @click.stop="onSecond">{{btnFont[1]}}</a>
				<a class="tips-two-btn" @click.stop="onCancel">{{btnFont.length > 2 ? btnFont[2] : btnFont[1]}}</a>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		btnNum: Number,
		tipsFont: String,
		tipsWork: String,
		hasTipsFont: Boolean,
		btnFont: Array
	},
	data () {
		return {
			tipsShow: true,
			topMove: false,
			tipsMaks: false,
			effect: ''
		}
	},
	methods: {
		closeMask () {
			this.topMove = false
			setTimeout(() => {
				this.tipsMaks = false
			}, 100)
		},
		tipStatus (msg) {
			this.tipsShow = false
			this.closeMask()
			this.$emit('tipStatus', msg)
		},
		onConfirmS () {
			if (this.btnFont.length > 2) {
				this.tipStatus(this.effect + '+agree')
			} else {
				this.tipStatus(this.effect)
			}
		},
		onSecond () {
			this.tipStatus(this.effect + '+disagree')
		},
		// 点击取消后的回调事件
		onCancelTipStatus (flag) {
			var msg = [flag]
			this.$emit('onCancelTipStatus', msg)
		},
		onCancel () {
			this.onCancelTipStatus(true)
			this.closeMask()
		},
		delay () {
			var self = this
			setTimeout(() => {
				self.tipStatus(false)
			}, 100)
		},
		open (val) {
			this.tipsMaks = true
			this.topMove = true
			this.effect = val
		}
	},
	computed: {
		upMove () {
			if (this.tipsState) {
				this.topMove = true
			} else {
				this.topMove = false
			}
			return this.topMove
		}
	}
}
</script>



// WEBPACK FOOTER //
// TipsT.vue?0ebaa65a